import { Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";
import CustomTable from "../common/Table";

function HotelWiseLikeDislike({ quotes_id }) {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [tableData, setTableData] = useState([]);
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        quotes_id,
    });

    const columns = [
        {
            title: "Hotel",
            dataIndex: "hotel_name",
            key: "hotel_name",
            width: 50,
        },
        {
            title: "Like",
            dataIndex: "like_count",
            key: "like_count",
            width: 25,
        },
        {
            title: "Dislike",
            dataIndex: "dislike_count",
            key: "dislike_count",
            width: 25,
        },
    ];

    const {
        status: hotelLikeDislikeStatus,
        data: hotelLikeDislikeRes,
        refetch: getHotelLikeDislike,
    } = useQuery(
        ["like-dislike", quotes_id],
        async () =>
            await HTTP("/dashboard/getLikeDislikesbyId", { ...formData }),
    );
    useEffect(() => {
        getHotelLikeDislike();
    }, []);

    useEffect(() => {
        getHotelLikeDislike();
    }, [formData]);

    useEffect(() => {
        if (hotelLikeDislikeStatus === "success") {
            const { data: tableData } = hotelLikeDislikeRes;
            setTableData(tableData);
        }
    }, [hotelLikeDislikeStatus, hotelLikeDislikeRes]);

    useEffect(() => {
        let [start_date, end_date] = selectedDates;
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        setFormData({
            ...formData,
            start_date,
            page: 0,
            end_date,
        });
    }, [selectedDates]);

    return (
        <>
            {hotelLikeDislikeStatus !== "idle" &&
            hotelLikeDislikeStatus !== "loading" ? (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    pagination={false}
                    rowKey="hotel_id"
                    isScroll
                />
            ) : (
                <Skeleton
                    active
                    paragraph={{ rows: 5, width: 10 }}
                    title={false}
                />
            )}
        </>
    );
}

export default HotelWiseLikeDislike;
